import styled from 'styled-components';

// Condensed "Capacity / Registered / Attended" pill for the session card
// (GROW-4314, SRD 1.2). The pill itself stays neutral; only the Registered
// number flips to the error color when it exceeds a numeric capacity.
export const SBadge = styled.span`
  display: inline-block;
  padding: 2px 10px;
  border: 1px solid ${({ theme }) => theme.colorBlackMainBorder};
  border-radius: ${({ theme }) => theme.borderRadiusSm}px;
  background: ${({ theme }) => theme.colorBlackFillQuaternary};
  font-weight: 600;
  white-space: nowrap;
  cursor: default;
`;

export const SSeparator = styled.span`
  white-space: pre;
  color: ${({ theme }) => theme.colorBlackTextSecondary};
  font-weight: 400;
`;

export const SRegistered = styled.span<{ $overCapacity: boolean }>`
  color: ${({ theme, $overCapacity }) =>
    $overCapacity ? theme.colorErrorActive : 'inherit'};
`;
